import Template from '@meteora-digital/template';
function splitText(holder) {
  var lines = holder.innerText.split('\n');
  holder.innerHTML = '';
  lines.forEach(function (line, lineIndex) {
    var words = line.split(' ');
    words.forEach(function (word) {
      var content = new Template({
        tagName: 'span',
        classList: 'split',
        innerHTML: [{
          tagName: 'span',
          classList: 'split__content',
          innerHTML: word
        }]
      });
      holder.appendChild(content.html);
    });
    holder.appendChild(document.createElement('br'));
  });
}
export default splitText;